<template>
  <div ref="bar">
    <!-- <div style="position: absolute; top: 0" class="top">
      <img src="../assets/tree-top.png" alt="" />
    </div> -->
    <!-- :style="{ visibility: open ? 'visible' : 'hidden' }" -->
    <div class="swift-logo">
      <div style="width: 180px;">

        <img :src="imageUrl" width="180" v-show="open" />
      </div> <!-- 公司logo显示位置-->

      <div class="tenantName">
        <div v-show="open">
          <div>{{ tenantName }}</div>
          <div style="color:#c6e4fe">{{ userName + "(" + loginId + ")" }}</div>
        </div>
        <div style="margin-left: auto;">
          <slot></slot>
        </div>
      </div>

    </div>
    <div>
      <el-menu class="el-menu-vertical-demo" :collapse="!open" :default-active="activePath" :collapse-transition="false"
        text-color="#c6e4fe" unique-opened active-text-color="#FFF" style="background: none">
        <MenuTree :menuList="menuList"> </MenuTree>
      </el-menu>
    </div>

    <!-- <div class="pro">
            <div class="pro-body">
              <div class="pro-con">
                <div>{{ $t("message.title.currentVolume") }}:</div>
                <el-progress
                  :text-inside="true"
                  :stroke-width="14"
                  :percentage="32"
                  style="margin-top: 6px"
                ></el-progress>
                <div class="pro-text">
                  <el-row>
                    <el-col :span="20">18.9 G / 60 G</el-col>
                    <el-col :span="4" class="link">{{
                      $t("message.title.dilation")
                    }}</el-col>
                  </el-row>
                </div>
              </div>
            </div>
          </div> -->
    <!-- <div class="tree-bottom">
      <img src="../../assets/tree-bottom.png" width="260px" alt="" />
    </div> -->
  </div>
</template>

<script>
import axios from "axios";
import commonstate from "@/utils/publicstate";
import { publicList } from "@/utils/publicstate";
import MenuTree from "../../components/Menu"; //引进菜单模板

export default {
  data() {
    return {
      imageUrl: require("../../assets/swift3.png"),

      tenantName: "",
      activePath: "",

      navList: publicList().navList,
      dropdownList: publicList().dropdownList,

      list: [],
      // menuList: [],
      menuListRows: [],
      defaultProps: {
        children: "children",
        label: "name",
        isLeaf: (node) => {
          return true;
        },
      },
      loginId: "",
      userName: "",
      barWidth: 221
    };
  },
  props: ["height", "open"],
  components: {
    MenuTree,
  },
  computed: {
    logoUrl() {
      return this.open ? "logo" : "icon";
    },
    treeOpen() {
      return true;
    },
    menuList() {
      if (this.open) {
        return this.list.filter((i) => !i.specialId);
      } else {
        return [...this.list];
      }
    },
    reloadSwiftLogo() {
      return this.$store.state.swiftLogo;
    },
    // dropdownList(){
    //   return commonstate.dropdownList;
    // }
    menuData() {
      return this.$store.state.menuData;
    },
    getTreeReload() {
      return this.$store.state.getTreeReload;
    },

  },
  watch: {
    getTreeReload: {
      handler() {
        this.loadData();
      }
    },
    menuData: {
      handler(val) {
        this.menuClick(val);
        // this.$store.commit('setPageRefresh',false)
      },
    },
    barWidth(val) {
      this.leftExpend = val > 220 && this.open
    },
    reloadSwiftLogo: {//监听首选项同步logo
      handler(val) {
        this.getIconImg();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    menuClick: function (data) {

      // this.$store.commit('setPageRefresh');
      if (data.parentId == 'setting') {
        this.handleCommand(data)
      } else if (data.url == "/importAgileList") {
        this.getConfirm();
      } else {
        if (!commonstate.urlList.some((i) => i.id == data.type)) {
          const n = data.id || "";
          // const item = { ...data, title: data.name, path: data.url, name: data.name + n };
          const item = { ...data, title: data.name, path: data.url, name: data.name };
          if (data.url == "/advancedSearch") {
            item.query = {
              seekId: item.id,
              seekName: item.name,
            }
            item.path = '/folderList'
          }
          if (data.id == 10405) {
            item.query = {
              isShow: true,
              seekId: item.id,
              seekName: item.name,
            };
            item.path = '/folderList'
          }
          if (data.url.toLowerCase().indexOf('report') !== -1) {
            item.query = {
              seekId: item.id,
              seekName: item.name
            }
          }
          if (data.url.toLowerCase().indexOf('view') !== -1) {
            item.query = {
              seekId: item.id,
              seekName: item.name
            }
          }
          const routePath = this.$route.path;
          this.$store.dispatch('setTabItem', item)

          this.$store.commit("setActivedTabInHome", item.name);
          this.$router.push({ path: item.path, query: item.query });
          if (['/globalSearch', '/personalSearch'].includes(routePath)) {
            this.$store.commit('setPageRefresh');
          }

        } else {
          this.loadObject(data);
        }
      }

    },
    getInfo() {
      axios.get("pmdm/agile/buildAndSaveListFromAgile").then((res) => {
        if (res.data.code == 200) {
          this.$message({
            type: "success",
            message: '导入成功',
          });
          let e = {
            "id": 1050102,
            "parentId": 10501,
            "name": "列表1050102",
            "url": "/lists",
            "icon": "",
            "children": [],
            "active": false,
            "title": "列表",
            "path": "/lists"
          }
          this.$router.push('/lists');
          this.$store.dispatch('setTabItem', e)

        }
      });
    },
    getConfirm() {
      this.$confirm(
        // this.$t("message.confirm.closeAllTabs"),
        '将从Agile系统导入list,已存在的值将会被覆盖,请确定？',
        this.$t("message.tips.tip"),
        {
          confirmButtonText: this.$t("message.button.affirm"),
          cancelButtonText: this.$t("message.button.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          this.getInfo();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("message.tips.cancel"),
          });
        });
    },
    tabAdd(e) {
      let obj = {
        path: e.path,
        query: {},
      };
      if ([10301, 10302, 10303, 10304].includes(e.id)) {
        obj.query = {
          isShow: true,
          seekId: e.id,
          seekName: e.name,
        };
      }
      this.$router.push(obj);
      this.$store.dispatch('setTabItem', e)

    },
    loadObject(e) {
      const objectInfo = {
        //获取url参数
        baseClassId: e.type,
        value: e.id,
      };
      let urlPre =
        e.type == 301 ? "/ppm/project/searchByObjId" : "/pmdm/search/byObjId";
      axios.get(`${urlPre + this.params(objectInfo)}`).then((res) => {

        const obj = { ...res.data.object.objectID };
        obj.title = res.data.object.objectName;
        this.getLink(obj);
        this.$store.commit("setPageRefresh");

      });
      // .then();
    },

    async getData() {
      const { data: menuList } = await this.$http.get("/pmdm/menus/tree");
      return { menuList };
    },
    setActive(arr) {
      let fun = (arr, level) => {
        let newArr = arr || [];
        let serial = level || "";
        newArr.map((i, e) => {
          i.active = false;
          let n = e + 1 + "";
          i.serial = !serial ? n : serial + "." + n;
          i.children && fun(i.children, i.serial);
        });
        return newArr;
      };
      return fun(arr);
    },

    loadData() {
      this.getData().then((res) => {
        this.$store.commit("setMenuList", res.menuList.object.tree);
        this.menuListRows = this.getAllRow(res.menuList.object.tree);
        const lastVisitList = this.menuListRows.find((i) => i.id == 10403)?.children || [];
        const navList = this.navList.map((i) => {
          const { name, path: url, children } = i;
          const obj = { name, url, children };
          return obj;
        });

        const dropdownList = this.dropdownList.map(i => ({
          name: i.title,
          id: i.id,
          link: i.link,
          path: i.link,
          parentId: 'setting',
          // children:[]
        }));

        const list = [
          {
            id: -1,
            parentId: 0,
            specialId: 2,
            url: "",
            icon: "el-icon-s-grid",
            children: [...navList],
          },

          {
            id: -2,
            parentId: 0,
            specialId: 2,
            url: "/advancedSearch",
            icon: "el-icon-zoom-in",
            children: [],
            parentId: 'setting'
          },
          {
            id: -3,
            parentId: 0,
            specialId: 2,
            url: "",
            icon: "el-icon-time",
            children: [...lastVisitList],
          },
          {
            id: -4,
            parentId: 0,
            specialId: 2,
            url: "",
            icon: "el-icon-user",
            children: [...dropdownList],
          },
        ];
        let arr = [...res.menuList.object.tree, ...list];
        this.list = this.setActive(arr);

        // let calendarList = res.calendar.object.map((i) => ({
        //   exceptionDate: i.exceptionDate.split("T")[0],
        //   exceptionType: i.exceptionType,
        // }));
        // this.$store.commit("setCalendar", calendarList);

        // const modules = window.sessionStorage.getItem("modules").split(",").map(Number);
        // if (modules.includes(2)) {
        //   this.$http.get("/ppm/calendar/loadCalendar?year=" + new Date().getFullYear()).then(res => {
        //     let calendarList = res.data.object.map((i) => ({
        //       exceptionDate: i.exceptionDate.split("T")[0],
        //       exceptionType: i.exceptionType,
        //     }));
        //     this.$store.commit("setCalendar", calendarList);
        //   })
        // }
      })
    },
    handleCommand(item) {
      if (item.link) {
        window.open(item.link);
      } else if (item.id == 'b') {
        this.updatePsd();
      } else if (item.id == 'c') {
        this.logout();
      } else {
        this.userSetting();
      }
    },

    logout() {
      this.$confirm(
        this.$t("message.confirm.logout"),
        this.$t("message.tips.tip"),
        {
          confirmButtonText: this.$t("message.button.affirm"),
          cancelButtonText: this.$t("message.button.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          return axios.get("/pmdm/logout")
        })
        .then(() => this.clearData())
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("message.tips.cancel"),
          });
        });
    },

    clearData() {
      window.sessionStorage.clear();
      this.$store.commit("clearShowingTabsInHome");
      this.$router.push("/index");
    },

    //个人设定
    userSetting() {
      var session = window.sessionStorage.getItem("userContext");
      session = JSON.parse(session);
      const { id, classId, subClassId } = session;
      const item = { id, classId, subClassId, 'name': '' };
      this.getLink(item);
      this.$store.commit("setPageRefresh");

    },

    advancedSearch() {
      let item = {
        title: this.$t("message.title.advancedSearch"),
        name: this.$t("message.title.advancedSearch"),
        path: "/advancedSearch",
        content: "/advancedSearch",
      };
      this.newTab(item);
      // this.routerReload();
    },

    newTab(item) {
      this.$router.push(item.path);
      this.$store.dispatch('setTabItem', item)
    },

    updatePsd() {
      let item = {
        title: this.$t("message.title.changePW"),
        name: this.$t("message.title.changePW"),
        path: "/upDatePsd",
        content: "/upDatePsd",
      };
      this.newTab(item);
    },
    getIconImg() {
      let vm = this;
      this.addNewFile = false;

      var getFile = {
        parentId: 0,
        parentClassId: 0,
        parentSubclassId: 0,
        parentChangeId: 0,
      };
      axios.get(`swift-file/icons/getIconsDownloadUrl${this.params(getFile)}`).then(res => {
        if (res.data.object.length !== 0) {
          vm.imageUrl = res.data.object[0].url;
        };
      }).catch(_ => { })
    },
    checkWidth() {
      const width = this.$refs.bar.offsetWidth;
      this.barWidth = width;
    }
  },
  created() {
    this.loadData();
    this.getIconImg();
    this.tenantName = window.sessionStorage.getItem("tenantName");
    this.loginId = JSON.parse(window.sessionStorage.getItem("userContext") || "[]").loginId;
    this.userName = JSON.parse(window.sessionStorage.getItem("userContext") || "[]").userName;
  },
  mounted() {
    window.addEventListener('resize', this.checkWidth)
  },
};
</script>

<style>
.el-menu {
  list-style: none;
  position: relative;
  margin: 0;
  border: none;
}

.el-submenu__title i {
  color: #fff !important;
}

.el-menu-item:hover {
  outline: 0 !important;
  color: #fff !important;
  background: #5cb0f9 !important;
}

.el-submenu__title:hover {
  outline: 0 !important;
  color: #fff !important;
  background: #5cb0f8 !important;
}

.el-submenu .is-active {
  background: #5cb0f8 !important;
}

.el-submenu .el-menu-item {
  height: 34px !important;
  line-height: 34px !important;
  min-width: 20px !important;
}
</style>

<style scoped>
.swift-logo {
  /* margin-left: 30px;
  margin-top: 70px;
  margin-bottom: 70px; */
  margin: auto;
  margin-top: 0px;
  margin-bottom: 40px;
  display: block;
  padding: 15px;
}

.swift-logo>img {
  width: 100%;
  height: 100%;
  /* max-width: 100%;
    max-height: 100%; */
}

.swift-logo2 {
  /* margin-left: 30px;
  margin-top: 70px;
  margin-bottom: 70px; */
  margin: auto;
  margin-top: 12px;
  margin-bottom: -55px;
  display: block;
  /* padding: 15px; */
}

.swift-logo2>img {
  width: 100%;
  height: 100%;
  /* max-width: 100%;
    max-height: 100%; */
}

.logo {
  width: 100%;
  height: 100%;
}

.logo:before {
  content: url("../../assets/swift-logo.png");
}

/* .swift-big:before{
    content: url('../../assets/swift-logo.png');
    width: auto;
  } */
.swift-big {
  background: url("../../assets/swift-logo.png");
}

.swift-icon:before {
  content: url("../../assets/swift-icon.png");
}

.tree {
  min-width: 154px;
  border-radius: 3px;
}

.uu {
  background: tomato;
  width: 150px;
  height: 600px;
  border-radius: 4px;
}

.tenantName {
  color: #fff;
  display: flex;
  height: 26px;
}

.top {
  /* width: 260px; */
  background-image: url(~@/assets/tree-top.png);
}

.tree-bottom {
  position: absolute;
  bottom: 0px;
  width: 260px;
  height: 395px;
  background-image: url(~@/assets/tree-bottom.png);
}


.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding: 0px 20px;
  height: 44px;
  line-height: 44px;
}

.node-icon {
  transition: -webkit-transform 0.3s;
  -webkit-transition: -webkit-transform 0.3s;
  transition: transform 0.3s;
  transition: transform 0.3s, -webkit-transform 0.3s;
  transition: transform 0.3s, -webkit-transform 0.3s;
}

.node-icon.isActive {
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
}

.node-label {
  font-size: 16px;
}

.pro {
  position: absolute;
  margin-top: 90px;
  /* margin-bottom: 25px; */
  /* padding-bottom:25px ; */
  /* width: 260px; */
  /* height: 90px; */
  padding: 35px 0;
  /* margin-left: 30px; */
  padding: 30px;
  z-index: 999;
}

.pro-body {
  width: 210px;
  height: 60px;
  padding: 15px;
  background: #fff;
  border-radius: 3px;
}

.pro-con {
  /* margin-top: 15px; */
  font-size: 14px;
}

.pro-text {
  margin-top: 8px;
}

.link {
  cursor: pointer;
  color: #3ea0fb;
  text-align: right;
}

.link:hover {
  text-decoration: underline;
}
</style>
